<template>
  <form novalidate class="md-layout-item md-size-100 md-small-size-100" @submit.prevent="validateUserContractSignGroup()">
        <md-content class="md-layout-item md-pd-16 md-size-100 md-small-size-100">
<div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getUserContractSignGroupValidationClass('users')" style="flex-wrap: wrap;">
            <label class="md-layout-item md-caption">Użytkownicy</label>
                <div v-for="(item, index) in users" :key="item.valueId">
                  <md-checkbox :disabled="isUser(users[index].keycloakId)" v-model="users[index].active" class="md-warn">{{ item.name ? item.name:users[index].name }}</md-checkbox>
                </div>
              </md-field>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30" style="min-height: 50px">
            <div class="button-actions">
              <md-button class="md-form-btn-cancel md-mr-30" @click="cancel">
                {{ $t('cancel') }}
              </md-button>
              <md-button class="md-form-btn-white" @click="onUserContractSignGroupSaved()">{{ $t('save') }}</md-button>
            </div>
          </div>
        </md-content>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate';
  import {configurationsEndpoint} from '@/services/adsign-backend/endpoints';
  import {mapGetters} from "vuex";

  export default {
    name: 'UsersContractSignGroupForm',
    mixins: [validationMixin],
    props: {
      id: {
        type: Number,
        default: undefined
      },
      groups:{
        type:Array,
        default:undefined
      },
      item: {
        type: Object,
        default: undefined
      },
      agency:{
        type:Number,
        default:undefined
      },
      index: {
        type: Number,
        default: undefined
      },
    },
    computed: {
      ...mapGetters("auth", ["userId","userName"]),
      edit: {
        get() {
          return this.id !== undefined;
        }
      }
    },
    data: () => ({
      values: [],
      users: {
        id: null,
        name: null,
        active:null,
      }
    }),

    validations: {
      users:{
        id:{},
        name:{},
        active:{}
    }},
    mounted() {
      configurationsEndpoint.getUsersForAgency(this.item.id).then(result=>{
        this.users = result.data.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      })
    },
    methods: {
      getUserContractSignGroupValidationClass(fieldName){
        const field = this.$v.users[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateUserContractSignGroup() {
        this.$v.users.$touch();

        if (!this.$v.users.$invalid) {
          this.onUserContractSignGroupSaved()
        }
      },
      onUserContractSignGroupSaved() {
            this.addUsersContractSignGroup();
      },

      isUser(userId){
        if(this.userId === userId){
            return true;
          }else{
            return false;
          }
      },

      addUsersContractSignGroup(){
        configurationsEndpoint.addUsersContractSignGroup(this.users,this.item.id)
        .then((response) => {
          this.cancel(response.data);
        })
        .catch(this.handleServerValidationError)
        .finally(() => {
              this.sending = false;
            }
        );
      },
      cancel(itemToPass) {
          this.$emit('users', {index: this.index});
      },
    }
  }
</script>
